import { request } from '@/shared/api/request'

export const setEmplSign = (data) => {
	return request({ url: `paryz/empl/sign`, method: 'post', data: data , headers: {
			'Content-Type': 'application/json'
		} })
}

export const setEmplXml = (data) => {
	return request({ url: `paryz/empl/xml`, method: 'post', data: data })
}


export const getEmplList = () => {
	return request({ url: `paryz/empl/list`, method: 'get' })
}